import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class LoginService {

  TOKEN = localStorage.getItem('token');
  constructor(private http: HttpClient) { }

  guardarToken(token: string): void {
    localStorage.setItem('token', 'token ' + token);
  }

  cerrarSesion(): void {
    localStorage.removeItem('token');
  }

  loginUser(userData):Observable<any>{
    return this.http.post(environment.BASE_URL+"/api/auth/", userData)
  }

  sendMessage(userData):Observable<any>{
    return this.http.post(environment.BASE_URL+"/api/sendSms/", userData)
  }


  getDataCliente(): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getDataCliente/",  {headers});
  }

}
